var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCheckCircleWhiteDarkblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.484375,
    y: 0.97998,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#0033AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48453 17.1498L5.31453 12.9798L3.89453 14.3898L9.48453 19.9798L21.4846 7.97982L20.0746 6.56982L9.48453 17.1498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckCircleWhiteDarkblue);
export default __webpack_public_path__ + "static/media/ic_check_circle_white_darkblue.c1760036c97a46dde37248ef78dcac0d.svg";
export { ForwardRef as ReactComponent };